// @flow
import { fetchBidderDataIfNeeded, getAuthToken } from './user';
import { postUpdateProfile, type UpdateProfileRequest } from '../api/bidder';
import { createSelector } from 'reselect';
import { getDeployment } from './config';
import type { GlobalState } from '../rootReducer';

/* Action Types */
export const UPDATE_ACCOUNT_FAIL = 'la/ui/updateAccount/FAIL';
export const UPDATE_ACCOUNT_REQUEST = 'la/ui/updateAccount/REQUEST';
export const UPDATE_ACCOUNT_SUCCESS = 'la/ui/updateAccount/SUCCESS';

/* reducer */
const DEFAULT_STATE = {
    error: false,
    errorMessage: null,
    submitted: false,
    success: false,
};

export type State = {|
    ...typeof DEFAULT_STATE,
    errorMessage: ?string,
|};

const pullMessages = messages => {
    return Object.keys(messages)
        .map(key => messages[key])
        .join(' ');
};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case UPDATE_ACCOUNT_FAIL:
            return {
                ...state,
                error: true,
                errorMessage: pullMessages(action.payload),
                submitted: false,
                success: false,
            };
        case UPDATE_ACCOUNT_REQUEST:
            return {
                ...state,
                submitted: true,
                success: false,
            };
        case UPDATE_ACCOUNT_SUCCESS:
            return {
                ...state,
                error: false,
                errorMessage: null,
                submitted: false,
                success: true,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.updateAccount;

export const getUiUpdateAccount = createSelector(stateSelector, state => state);

/* ACTION CREATORS */
export const updateAccountDetails = (updatedProfile: UpdateProfileRequest) => async (
    dispatch: Function,
    getState: Function
) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);

        dispatch({
            type: UPDATE_ACCOUNT_REQUEST,
        });

        const response = await postUpdateProfile({
            authToken,
            deployment,
            profile: updatedProfile,
        });

        dispatch({
            meta: { actionTime: Date.now() },
            payload: response,
            type: UPDATE_ACCOUNT_SUCCESS,
        });

        return dispatch(fetchBidderDataIfNeeded(null, true));
    } catch (error) {
        dispatch({
            error: true,
            payload: error,
            type: UPDATE_ACCOUNT_FAIL,
        });
    }
};
